import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router";
import EntityTable from "../../common/tables/EntityTable";
import { ActivityEnumsLists } from "../../../common/constants";
import { GetResourceLink } from "../../../common/activity";
import { TimeView } from "../../common/core/Time";
import config from "../../../config";

export default function ActivityLogPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns = useMemo(() => {
    return [
      {
        field: "number",
        type: "number",
        headerName: t("common:tables:number"),
        flex: 0.5
      },
      {
        field: "created",
        headerName: t("common:tables:created"),
        type: "dateTime",
        valueGetter: (value) => new Date(value),
        renderCell: (params) => <TimeView time={params.row.created} />,
        flex: 1,
        minWidth: 120,
      },
      {
        field: "activityCategory",
        headerName: t("activityLog:fieldCategory"),
        type: "singleSelect",
        flex: 0.75,
        minWidth: 120,
        valueFormatter: (value) => t(`activity:enums:category:${ActivityEnumsLists.Category[value]}`),
        valueOptions: ActivityEnumsLists.Category.map((_, value) => ({
          value,
          label: t(`activity:enums:category:${ActivityEnumsLists.Category[value]}`)
        }))
      },
      {
        field: "activityType",
        type: "singleSelect",
        headerName: t("activityLog:fieldType"),
        flex: 1,
        minWidth: 120,
        valueFormatter: (value) => t(`activity:enums:type:${ActivityEnumsLists.Type[value]}`),
        valueOptions: ActivityEnumsLists.Type.map((_, value) => ({
          value,
          label: t(`activity:enums:type:${ActivityEnumsLists.Type[value]}`),
        })).filter(t => !!t.label)
      },
      {
        field: "resourceNumber",
        type: "number",
        headerName: t("common:tables:resourceNumber"),
        valueFormatter: (value) => !!value ? `#${value}` : "-",
        flex: 0.75,
        minWidth: 60,
      },
      {
        field: "description",
        headerName: t("common:description"),
        valueGetter: (_, row) => row.description || "-",
        flex: 0.75,
        minWidth: 80,
      },
      {
        field: "sender.name",
        headerName: t("activityLog:fieldSender"),
        valueGetter: (_, row) => row.sender?.name || "-",
        flex: 1,
        minWidth: 120,
      }
    ]
  }, [t]);


  const onRowClick = useCallback((params, ev) => {
    navigate(GetResourceLink(params.row), { relative: "path" });
  }, [navigate]);

  return (
    <ResponsivePage
      maxWidth={config.pageSize.medium}
      title={t("activityLog:title")}
    >

      <EntityTable
        tableId="activity_log"
        type="ActivityLog"
        columns={columns}
        onRowClick={onRowClick}
        emptyStateTitle={t("activityLog:emptyStateTitle")}
        emptyStateDescription={t("activityLog:emptyStateDescription")}
        sortDescendingByDefault
        serverSidePaging
        xs={12}
      />

    </ResponsivePage>
  );
}